import React from 'react';

var LobbyHeader = function (_a) {
    var _b = _a.iconName, iconName = _b === void 0 ? 'icon-info1' : _b, openHelpPopup = _a.openHelpPopup;
    return (React.createElement("div", { className: 'pgc-lobby-head' },
        React.createElement("i", { className: " ".concat(iconName), onClick: openHelpPopup })));
};

export { LobbyHeader };
